var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFillBusinessSendPlaneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9011 7.91524C11.6595 7.42089 11.8565 7.22043 12.3605 7.47814L30.2736 16.6384C30.7698 16.8925 30.7709 17.3161 30.2976 17.5734L12.8588 27.0554C12.3763 27.3191 12.1497 27.1141 12.3509 26.6025L15.6032 18.3712L25.5151 17.0465L15.6288 15.5429L11.9011 7.91524Z",
    fill: "#86888C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillBusinessSendPlaneFill);
export default __webpack_public_path__ + "static/media/icon-fill-business-send-plane-fill.7c049485abf09a37e464f055d9d38833.svg";
export { ForwardRef as ReactComponent };